import { useContext } from 'react';
import Login from '../components/Login/Login';
import Reviewer from './Homepages/Reviewer';
import NewsPage from '../pages/News/Page';
import { AuthContext } from '../AuthContext';


const HomePage = () => {
    const user = useContext(AuthContext);
console.log('user');
console.log(user);
    const roles = user?.roles;

    if (roles && roles.includes('REVIEWER')) {
        return <Reviewer />;
      } else {
        return <NewsPage />;
      }

  };

export default HomePage;
